<template>
  <router-view />
</template>

<script>

export default {
  name: 'OrganizationWrapper'
}
</script>
